import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

const getEmployeePermissions = async (data?: GetEmployeePermissionsReqT) =>
  axios.get(Routes.GET_EMPLOYEE_PERMISSIONS + "?user_id=" + data?.user_id);

export const useGetEmployeePermissions = (data?: GetEmployeePermissionsReqT) =>
  useQuery({
    queryKey: [Keys.EMPLOYEE_PERMISSIONS, data?.user_id],
    queryFn: () => getEmployeePermissions(data),
    cacheTime: 0,
  });
